export const useDialog = () => {
  const dialogVisible = ref(false)

  const openDialog = () => {
    dialogVisible.value = true
  }

  const closeDialog = () => {
    dialogVisible.value = false
  }

  watch(
    () => dialogVisible.value,
    (val) => {
      if (val) {
        document.documentElement.style.overflow = 'hidden'
      } else {
        document.documentElement.style.overflow = 'initial'
      }
    },
    {
      immediate: true,
    },
  )

  return {
    dialogVisible,
    openDialog,
    closeDialog,
  }
}
